module.exports = __webpack_public_path__ + "static/media/img-card-three.c616a995.jpg";